seller_store.search = {

    updateMobileOrdering: function()
    {
        $('body').on('change', 'select#mobile_order_by', function () {
            window.location = seller_store.base.updateQueryStringParameter(window.location.href, 'order_by', this.value);
        });
    }
}